import React from 'react';

// Precision Wealth official logo (double-stroke "P" mark over PRECISION / WEALTH wordmark).
// Rendered from transparent PNGs generated from the brand asset.
// variant: 'light' -> ivory logo (for dark backgrounds)
//          'dark'  -> navy logo  (for light backgrounds)
// size: 'sm' | 'md' | 'lg'   (layout prop accepted but the lockup is a single image)
export const PW_GOLD = '#C0975C';
export const PW_IVORY = '#F5F1E8';

const SIZES = { sm: 34, md: 46, lg: 74 };

export default function Logo({ variant = 'light', size = 'md', className = '' }) {
  const src = variant === 'light' ? '/brand/logo-ivory.png' : '/brand/logo-navy.png';
  const height = SIZES[size] || SIZES.md;
  return (
    <img
      src={src}
      alt="Precision Wealth"
      draggable={false}
      style={{ height, width: 'auto' }}
      className={className}
    />
  );
}
